import React, { useEffect, useState } from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import { Link, useNavigate } from "react-router-dom";
import * as Yup from "yup";
import {
  checkInfluencerCode,
  getCountryList,
  isUserExist,
  register,
} from "../api/api";
import "../RegistrationPage/RegistrationPage.css";
import { v4 as uuidv4 } from "uuid";
import Swal from "sweetalert2";

const RegistrationPage = () => {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const [jwtsToken, setjwtsToken] = useState("");
  const [isCodeValid, setIsCodeValid] = useState("");
  const [country, setCountry] = useState([]);
  const [initialCountry, setInitialCountry] = useState(null);
  useEffect(() => {
    const generatedToken = uuidv4().replace(/-/g, "").substring(0, 32);
    console.log("Generated Token form userRegistraion page:", generatedToken);
    setjwtsToken(generatedToken);
    localStorage.setItem("jwtToken", generatedToken);
  }, []);
  useEffect(() => {
    CountryList();
  }, []);

  const validationSchema = Yup.object({
    name: Yup.string().required("Name is required"),
    profession: Yup.string().required("Profession is required"),
    email: Yup.string()
      .email("Invalid email format")
      .required("Email is required"),
    // dob: Yup.date().required("Date of Birth is required"),
    dob: Yup.date()
      .max(new Date(), "Date of Birth cannot be in the future")
      .required("Date of Birth is required"),
    country: Yup.string().required("Country is required"),
    phoneCode: Yup.string().required("Phone code is required"),
    phone: Yup.string()
      .matches(/^\d{5,13}$/, "Phone number must be 5 or 13 digits")
      .required("Phone Number is required"),
    password: Yup.string()
      .min(6, "Password must be at least 6 characters")
      .required("Password is required"),
    confirmPassword: Yup.string()
      .oneOf([Yup.ref("password"), null], "Passwords must match")
      .required("Confirm Password is required"),
    acceptTerms: Yup.bool().oneOf(
      [true],
      "You must accept the Terms and Conditions"
    ),
  });

  const handleCustomChange = async (value, setFieldValue, setFieldError) => {
    setFieldValue("email", value.toLowerCase());
    try {
      const response = await isUserExist({ email: value.toLowerCase() });
      if (response?.success === false) {
        setFieldError("email", response.message);
      } else {
        setFieldError("email", "");
      }
    } catch (error) {
      console.error("Error checking email:", error);
    }
  };

  const CountryList = async () => {
    try {
      const response = await getCountryList();
      console.log("cuntryList", JSON.stringify(response));
      const countriesArray = response?.data || [];
      const formattedCountries = countriesArray.map((c) => ({
        label: `${c.name} (${c.phoneCode})`,
        value: c.phoneCode,
        country_name: c.name,
        country_code: c.countryCode,
        phone_code: c.phoneCode,
      }));
      const sortedCountries = [
        ...formattedCountries.filter((c) => c.value === "United Kingdom"),
        ...formattedCountries.filter((c) => c.value !== "United Kingdom"),
      ];

      setCountry(sortedCountries);
      const defaultCountry = sortedCountries.find(
        (c) => c.country_name === "United Kingdom"
      );
      if (defaultCountry) {
        setInitialCountry(defaultCountry);
      }
    } catch (error) {
      console.error(error);
    }
  };

  // const handleSubmit = async (values) => {
  //   console.log("Form Values:", values);
  //   setIsLoading(true);
  //   try {
  //     const registerFormData = { ...values };
  //     console.log("Registraton_-____from___value", registerFormData);
  //     const firstPaymentResponse = await register(registerFormData);
  //     console.log("registerFormData-Value", firstPaymentResponse);
  //     if (firstPaymentResponse?.data) {
  //       localStorage.setItem(
  //         "currentUser",
  //         JSON.stringify(firstPaymentResponse?.data)
  //       );
  //     }
  //     if (
  //       firstPaymentResponse?.data?.profile_completion_status ===
  //       "RegistrationVarification"
  //     ) {
  //       Swal.fire("Success", firstPaymentResponse?.message, "success").then(
  //         () => {
  //           console.log("Swal closed. Navigating...");
  //           navigate("/RegistrationVarification", {
  //             state: { email: values.email },
  //           });
  //         }
  //       );
  //     } else {
  //       const emailErrors = firstPaymentResponse?.message?.email;
  //       const errorMessage = emailErrors
  //         ? emailErrors.join("\n")
  //         : "Something went wrong";
  //       // alert(errorMessage);
  //       Swal("Error", errorMessage, "error");
  //     }
  //   } catch (error) {
  //     Swal("Error", "Something went wrong", "error");
  //     console.error("Submit error:", error);
  //   } finally {
  //     setIsLoading(false);
  //   }
  // };

  const handleSubmit = async (values) => {
    console.log("Form Values:", values);
    setIsLoading(true);
    try {
      const registerFormData = { ...values };
      const firstPaymentResponse = await register(registerFormData);

      if (firstPaymentResponse?.data) {
        localStorage.setItem(
          "currentUser",
          JSON.stringify(firstPaymentResponse?.data)
        );
      }

      if (firstPaymentResponse?.success) {
        Swal.fire("Success", firstPaymentResponse?.message, "success").then(
          () => {
            if (
              firstPaymentResponse?.data?.profile_completion_status ===
              "RegistrationVarification"
            ) {
              navigate("/RegistrationVarification", {
                state: { email: values.email },
              });
            }
          }
        );
      } else {
        // Error case
        const emailErrors = firstPaymentResponse?.message?.email;
        const errorMessage = emailErrors
          ? emailErrors.join("\n")
          : firstPaymentResponse?.message;

        Swal.fire("Error", errorMessage, "error");
      }
    } catch (error) {
      Swal.fire("Error", "Something went wrong", "error");
      console.error("Submit error:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleCustomChangeCode = async (value, setFieldValue) => {
    setFieldValue("influencer_code", value);
    try {
      const response = await checkInfluencerCode({ influencer_code: value });
      console.log("influencer_code_response", response?.influencer?.id);
      if (response?.success && response?.influencer?.id) {
        console.log("success");
        setIsCodeValid(response?.message);
        // if (response?.influencer?.id) {
        setFieldValue(
          "influencer_id",
          response.influencer.id || response.influencer._id
        );
        // }
      } else {
        console.log("error");
        setIsCodeValid(response?.message);
        setFieldValue("influencer_id", "");
      }
    } catch (err) {
      console.error("Influencer code check failed:", err);
      setIsCodeValid("Something went wrong");
      setFieldValue("influencer_id", "");
    }
  };

  return (
    <div className="registration-box">
      <h1>Register</h1>

      <Formik
        enableReinitialize
        initialValues={{
          name: "",
          email: "",
          dob: "",
          phoneCode: initialCountry?.phone_code || "+44",
          phone: "",
          password: "",
          profession: "",
          confirmPassword: "",
          acceptTerms: false,
          influencer_code: "",
          influencer_id: "",
          address: "",
          bio: "",
          token: "",
          country: initialCountry?.country_name || "",
          country_name: initialCountry?.country_name || "",
          country_code: initialCountry?.country_code || "",
          profile_completion_status: "RegistrationVarification",
          jwtsecret: jwtsToken,
        }}
        validationSchema={validationSchema}
        onSubmit={handleSubmit}
      >
        {({ isSubmitting }) => (
          <Form className="registration-form">
            <div className="registerform-group">
              <div className="UserlabelDiv">
                <label>Name</label>
              </div>
              <Field
                type="text"
                name="name"
                className="form-input"
                placeholder=""
              />
            </div>
            <ErrorMessage
              name="name"
              component="div"
              className="error-message"
            />
            <div className="registerform-group">
              <div className="UserlabelDiv">
                <label>Email</label>
              </div>
              <Field name="email">
                {({ field, form }) => (
                  <input
                    {...field}
                    type="email"
                    className="form-input"
                    placeholder=""
                    onChange={(e) =>
                      handleCustomChange(
                        e.target.value,
                        form.setFieldValue,
                        form.setFieldError
                      )
                    }
                  />
                )}
              </Field>
            </div>
            <ErrorMessage
              name="email"
              component="div"
              className="error-message"
            />
            <div className="registerform-group">
              <div className="UserlabelDiv">
                <label>Country Code</label>
              </div>
              <Field name="phoneCode">
                {({ field, form }) => (
                  <select
                    {...field}
                    className="form-input"
                    onChange={(e) => {
                      const selectedCode = e.target.value;
                      const selectedCountry = country.find(
                        (c) => c.phone_code === selectedCode
                      );
                      form.setFieldValue("phoneCode", selectedCode);
                      form.setFieldValue(
                        "country",
                        selectedCountry.country_name
                      );
                      form.setFieldValue(
                        "country_name",
                        selectedCountry.country_name
                      );
                      form.setFieldValue(
                        "country_code",
                        selectedCountry.country_code
                      );
                    }}
                  >
                    <option value="">Select Country</option>
                    {country.map((c) => (
                      <option key={c.country_code} value={c.phone_code}>
                        {c.country_name} ({c.phone_code})
                      </option>
                    ))}
                  </select>
                )}
              </Field>
              <ErrorMessage
                name="phoneCode"
                component="div"
                className="error-message"
              />
            </div>
            <div className="registerform-group">
              <div className="UserlabelDiv">
                <label>Phone Number</label>
              </div>
              <Field
                type="tel"
                name="phone"
                className="form-input"
                placeholder=""
              />
            </div>
            <ErrorMessage
              name="phone"
              component="div"
              className="error-message"
            />
            <div className="registerform-group">
              <div className="UserlabelDiv">
                <label>Password</label>
              </div>
              <Field
                type="password"
                name="password"
                className="form-input"
                placeholder=""
              />
            </div>
            <ErrorMessage
              name="password"
              component="div"
              className="error-message"
            />

            <div className="registerform-group">
              <div className="UserlabelDiv">
                <label>Confirm Password</label>
              </div>
              <div>
                <Field
                  type="password"
                  name="confirmPassword"
                  className="form-input"
                  placeholder=""
                />
              </div>
            </div>
            <ErrorMessage
              name="confirmPassword"
              component="div"
              className="error-message"
            />

            <div className="registerform-group">
              <div className="UserlabelDiv">
                <label>Profession</label>
              </div>
              <Field
                type="text"
                name="profession"
                className="form-input"
                placeholder=""
              />
            </div>
            <ErrorMessage
              name="profession"
              component="div"
              className="error-message"
            />
            <div className="registerform-group">
              <div className="UserlabelDiv">
                <label>Date of Birth</label>
              </div>
              <Field type="date" name="dob" className="form-input" />
            </div>
            <ErrorMessage
              name="dob"
              component="div"
              className="error-message"
            />
            <div className="registerform-group">
              <div className="UserlabelDiv">
                <label>Address</label>
              </div>
              <Field type="text" name="address" className="form-input" />
            </div>
            <div className="registerform-group">
              <div className="UserlabelDiv">
                <label>Bio</label>
              </div>
              <Field
                as="textarea"
                name="bio"
                className="form-input"
                rows="4"
                placeholder="Tell us something about yourself..."
              />
            </div>
            <div className="registerform-group">
              <div className="UserlabelDiv">
                <label>Influencer Code (Optional)</label>
              </div>
              <Field name="influencer_code">
                {({ field, form }) => (
                  <input
                    {...field}
                    type="text"
                    className="form-input"
                    placeholder=""
                    // onChange={(e) =>
                    //   handleCustomChangeCode(e.target.value, form.setFieldValue)
                    // }
                    onChange={async (e) => {
                      const value = e.target.value;
                      form.setFieldValue("influencer_code", value);
                      await handleCustomChangeCode(value, form.setFieldValue);
                    }}
                  />
                )}
              </Field>
              {isCodeValid !== "" && (
                <div
                  className="error-message"
                  style={{ marginTop: "5px", color: "#e04a48" }}
                >
                  {isCodeValid}
                </div>
              )}
            </div>

            <div className="termform-group">
              <Field
                type="checkbox"
                name="acceptTerms"
                className="form-checkbox"
              />
              <label>
                I accept the{" "}
                <Link
                  to="/termsandcondition"
                  style={{ color: "#058787", textDecoration: "none" }}
                >
                  Terms and Conditions {" / "}
                </Link>
                <Link
                  to="/privacypolicy"
                  style={{ color: "#058787", textDecoration: "none" }}
                >
                  Privacy policy
                </Link>
              </label>
            </div>

            <ErrorMessage
              name="acceptTerms"
              component="div"
              className="termserror-message"
            />

            <button
              type="submit"
              className="register-button"
              disabled={isSubmitting || isLoading}
            >
              {isLoading ? "Registering..." : "Register"}
            </button>
            <button
              type="submit"
              className="counsellor-register-button"
              onClick={() => navigate("/CounsellorRegistration")}
            >
              Counsellor Register & Login
            </button>
          </Form>
        )}
      </Formik>
    </div>
  );
};

export default RegistrationPage;
